/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clipboard': {
    width: 8,
    height: 11,
    viewBox: '0 0 8 11',
    data: '<path pid="0" d="M6.47 1.485h-.306v-.343a.447.447 0 0 0-.437-.457h-.623A1.25 1.25 0 0 0 4 0c-.46 0-.884.263-1.104.685h-.612a.447.447 0 0 0-.437.457v.343H1.53c-.845 0-1.53.716-1.53 1.6V9.4C0 10.284.685 11 1.53 11h4.94C7.315 11 8 10.284 8 9.4V3.085c0-.883-.685-1.599-1.53-1.599zm-3.749.114h.481a.442.442 0 0 0 .426-.365A.388.388 0 0 1 4.005.9c.187 0 .346.14.378.333.04.212.219.364.426.365h.48v.628H2.722V1.6zm4.405 7.802c0 .378-.294.685-.656.685H1.53c-.362 0-.656-.307-.656-.685V3.084c0-.378.294-.685.656-.685h.306v.285c0 .253.196.457.437.457h3.454a.447.447 0 0 0 .437-.457V2.4h.306c.362 0 .656.307.656.685v6.317z" _fill="#376F99" fill-rule="nonzero"/>'
  }
})
